import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "motowear_token";
const USER_KEY = "motowear_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};
export const getStoredUser = () => {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw || raw === "undefined" || raw === "null") return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    // Corrupt cached user — wipe it so we don't crash on every reload.
    localStorage.removeItem(USER_KEY);
    return null;
  }
};
export const setStoredUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u));

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default client;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 2 }).format(Number(n) || 0);

// resolveImageUrl: normalise image URLs so they always load against the
// *current* backend, regardless of which environment originally wrote them.
//
// Background: admin uploads historically saved the full preview URL (e.g.
// https://collection-catalog.preview.emergentagent.com/api/files/...) into
// MongoDB. When the same database is read from the production storefront
// (motowear.co.uk) those preview-prefixed URLs can render as broken
// thumbnails. By stripping any backend host and always prepending the
// current REACT_APP_BACKEND_URL we ensure the storefront fetches files
// from the matching environment.
export function resolveImageUrl(u) {
  if (!u || typeof u !== "string") return "";
  const s = u.trim();
  if (!s) return "";
  // Object-storage uploads are always served from the same origin as the
  // page via the Kubernetes ingress (e.g. motowear.co.uk/api/files/... in
  // prod, preview-host/api/files/... in dev). Always rewrite to the
  // current origin so a stale baked-in REACT_APP_BACKEND_URL (pointing at
  // a retired host) does not leave images broken on the live storefront.
  const origin = (typeof window !== "undefined" && window.location && window.location.origin) || BACKEND_URL || "";
  // Already relative — just prefix with origin.
  if (s.startsWith("/api/files/")) return `${origin}${s}`;
  // Full URL that points at our object-storage endpoint (any historical
  // backend host). Detect by the "/api/files/" segment and rewrite.
  const idx = s.indexOf("/api/files/");
  if (idx > -1 && /^https?:\/\//i.test(s)) {
    return `${origin}${s.slice(idx)}`;
  }
  // External CDN / data URL / already-correct — leave alone.
  return s;
}
